// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.missionary-details {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #ffffff;
}
.details-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.detail-row {
  display: flex;
  gap: 1rem;
}
.detail-row label {
  font-weight: 600;
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MissionaryDashboard/style.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ","sourcesContent":[".missionary-details {\n    margin-top: 1rem;\n    padding: 1rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    background-color: #ffffff;\n  }\n\n  .details-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .detail-row {\n    display: flex;\n    gap: 1rem;\n  }\n\n  .detail-row label {\n    font-weight: 600;\n    min-width: 120px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
